import { GetStaticProps, GetStaticPaths } from "next";
import Layout from "../../../components/layout";
import React, { useState } from "react";
import ContactUSPopup from "../../../components/v2/form/contact-us-popup";
const parentPage = "events";
import Modal from "react-modal";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";
let isValidInputs = true;

export default function PressReleaseNews() {
  const [isOpen, setIsOpen] = useState(false);

  function toggleModal() {
    setIsOpen(!isOpen);
  }
  return (
    <>
      <Layout
        isHomePage={false}
        pageTitle={"Checkout all the official press releases from Middleware."}
        ogImage={
          "https://middleware.io/backend/wp-content/uploads/2023/09/docker-mw.png"
        }
        uri={"/resources/press-release/"}
        metaTitle={"Checkout all the official press releases from Middleware."}
        metaDesc={"Get all Middleware PR syndicated in one place."}
        metaRobotsNoindex={"index"}
        metaRobotsNofollow={"follow"}
      >
        <section className={"main-news-page"}>
          <div className={"hero-news"}>
            <div className={"container"}>
              <h1>In the News</h1>
              <p>
                Read all about what’s and what’s next, and see why <br />{" "}
                Middleware always makes headlines.
              </p>
              <button onClick={toggleModal}>PR inquiries</button>
              <Modal
                isOpen={isOpen}
                onRequestClose={toggleModal}
                contentLabel="My dialog"
                className="mymodal contact-modal"
                overlayClassName="myoverlay"
                closeTimeoutMS={500}
              >
                <div className={"pop-up-contactus"}>
                  <ContactUSPopup />
                  <button className={"close-btn"} onClick={toggleModal}>
                    <img src={"/images/pop-up/close.svg"} />
                  </button>
                </div>
              </Modal>
            </div>
          </div>
          <div className={"container"}>
            <div className={"news-list"}>
              <div className={"d-flex"}>
                <div className={"left-block"}>
                  <div className={"left-sticky"}>
                    <ul>
                      <a href={"/resources/press-release/"}>
                        <li className={"active"}>Press release</li>
                      </a>
                      <a href={"/resources/media-coverage/"}>
                        <li className={""}>Media coverage</li>
                      </a>
                      <a href={"/"}>
                        <li className={"coming"}>Press kit</li>
                      </a>
                    </ul>
                  </div>
                </div>
                <div className={"right-block"}>
                  <div className={"d-flex"}>
                    <div className={"news-block"}>
                      <div className={"news-img"}>
                        <a
                          href={
                            "https://www.prnewswire.com/news-releases/middleware-launches-ai-powered-observability-platform-for-cloud-native-301740450.html"
                          }
                          target={"_blank"}
                        >
                          <img
                            src={"/images/news/middleware-cision.png"}
                            alt={"Middleware Venturebeat"}
                          />
                        </a>
                      </div>
                      <div className={"news-content"}>
                        <h5>
                          Middleware Launches an AI-powered observability
                          platform for cloud-native.
                        </h5>
                        <p className={"date"}>November 23, 2023</p>
                        <a
                          href={
                            "https://www.prnewswire.com/news-releases/middleware-launches-ai-powered-observability-platform-for-cloud-native-301740450.html"
                          }
                          target={"_blank"}
                        >
                          <button className={"borderless arrow"}>
                            Learn more{" "}
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
  return {
    props: {
      ...translations,
      pageData: "",
      pageTitle: "Checkout all the official press releases from Middleware.\n",
      description: "Get all Middleware PR syndicated in one place.",
      uri: "/resources/press-release/",
      metaTitle: "Checkout all the official press releases from Middleware.\n",
      metaDesc: "Get all Middleware PR syndicated in one place.",
      metaRobotsNoindex: "index",
      metaRobotsNofollow: "follow",
    },
  };
};
